import { render, staticRenderFns } from "./new-salary-mapping-form.vue?vue&type=template&id=679e779b"
import script from "./new-salary-mapping-form.vue?vue&type=script&lang=js"
export * from "./new-salary-mapping-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports